var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _path12, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanSubmarineContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 25.2124C12.656 27.0764 15.1307 37.7516 14.976 39.1072L29.6693 33.007C26.2666 29.7875 18.7808 23.7213 16.0587 25.2124Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 64.9557C12.656 63.0917 15.1307 52.4165 14.976 51.0609L29.6693 57.161C26.2666 60.3806 18.7808 66.4468 16.0587 64.9557Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6273C6.40665 42.6235 4.77775 36.0903 7.57015 33.9876C10.3626 31.885 8.73365 40.8713 7.57015 45.6273Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6275C6.40665 48.3583 4.77775 54.2976 7.57015 56.2091C10.3626 58.1206 8.73365 49.9512 7.57015 45.6275Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5272 29.5114C77.0168 31.5313 77.9997 36.8703 77.9997 44.8337L77.9999 45.3038C78.0044 56.8139 78.0073 63.9753 52.865 63.9753C28.196 63.9753 10.5806 55.2854 9.48055 46.6087H8.7301C8.67827 47.1404 8.55312 47.685 8.31948 48.2029C7.32364 50.4103 5 47.0992 5 45.9955C5 44.8918 8.00882 42.4391 8.31948 43.5428C8.45988 43.8886 8.62403 44.4596 8.70645 45.1371H9.44849C9.95277 38.3342 18.9079 33.444 35.5704 30.6981C36.1866 28.521 37.1918 25.443 38.8732 24.1467C41.0316 22.4825 44.3376 19.9553 49.237 18.9523C49.237 14.4074 49.237 13.5062 50.347 11.6552C51.6708 9.44774 54.0622 9.07076 56.3993 9.04542C56.8878 9.04013 57.3298 9.03533 57.7124 9C57.9657 9.43382 58.2559 10.2728 58.1728 11.2531C58.1228 11.8431 57.7124 13.1696 57.7124 13.1696C57.7124 13.1696 55.8486 13.2577 55.0185 13.1696C53.5183 13.0103 52.7299 13.5415 52.3148 13.9568C51.8642 14.4076 51.815 14.9774 51.856 18.6884C55.0234 18.8604 68.5272 19.4431 68.5272 24.1467V29.5114Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0862 22.9691C67.717 19.5725 55.0467 16.6707 51.864 16.2098C51.8299 16.9846 51.8566 18.6875 51.864 19.3642C54.064 19.4849 66.0858 20.8759 68.0862 22.9691Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2889 16.2098C46.8622 16.2241 42.8516 16.8941 41.0492 18.9134C39.6972 20.428 38.9424 22.8855 39.2467 23.8703C44.2035 20.2653 47.8084 19.3642 49.2889 19.3642C49.2239 18.5495 49.3104 17.1636 49.2889 16.2098Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6998,
    cy: 14.1903,
    rx: 13.6998,
    ry: 14.1903,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 45.3936 27.1541)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7338 49.6983C56.9056 53.7756 52.3296 55.4627 48.5482 53.5677C44.7668 51.6727 43.1055 46.8598 44.9337 42.7825C46.7619 38.7052 51.3379 37.0181 55.1193 38.9131C58.9007 40.8082 60.5621 45.6211 58.7338 49.6983Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3394 60.6032C29.9722 50.8616 31.9364 35.8476 33.3394 31.4763L30.9435 31.8546C28.4582 41.3152 29.4655 55.5145 30.6012 59.8467L33.3394 60.6032Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6003 60.4582C66.9613 49.4606 69.9295 35.5758 71.7947 30.4872L69.4059 29.7284C65.3026 41.0017 65.6122 50.7431 68.2114 61.2169L70.6003 60.4582Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6743 37.6952C75.6746 36.2187 73.3758 33.7143 72.2263 32.6466C70.6384 32.2873 70.9358 34.2004 71.7793 34.622C72.6229 35.0436 73.1932 37.1338 73.4658 38.6952C73.7385 40.2566 75.674 39.5409 75.6743 37.6952Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0485 24.3227C66.6797 22.7632 63.5144 20.6677 61.9778 19.8148C60.1339 19.8148 60.9406 21.7642 61.9778 22.0078C63.015 22.2515 64.1674 24.3227 64.8589 25.9065C65.5503 27.4903 67.5095 26.272 67.0485 24.3227Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1953,
    y: 43.4541,
    width: 14.3904,
    height: 5.4333,
    rx: 2.71665,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanSubmarineContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanSubmarine-contrast.14b8f243989bf3e38622c8f4935b162f.svg";